import React from "react";
import { useProductContext } from "../providers/ProductContextProvider";
import { isFeatureAllowedForLocale } from "../languageFeatures";
import FeatureUnavailable from "../pages/FeatureUnavailable";

/**
 * Gate UI by route-registry feature key + locale feature scope.
 */
export function FeatureGate({ feature, children, fallback = null }) {
  const { locale } = useProductContext();
  const allowed = isFeatureAllowedForLocale(locale, feature);

  if (!allowed) {
    return fallback ?? <FeatureUnavailable feature={feature} />;
  }
  return children;
}

export default FeatureGate;
